/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SchedulationResponse } from '../../models/schedulation-response';
import { SchedulationUpdateRequest } from '../../models/schedulation-update-request';

export interface PutFeV1SchedulationsId$Json$Params {

/**
 * The hashed schedulation ID.
 */
  id: string;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;

/**
 * Unique identifier for tracing the request across services
 */
  'X-Correlation-Id'?: string;
  
    /**
     * Schedulation update data.
     */
    body?: SchedulationUpdateRequest
}

export function putFeV1SchedulationsId$Json(http: HttpClient, rootUrl: string, params: PutFeV1SchedulationsId$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SchedulationResponse>> {
  const rb = new RequestBuilder(rootUrl, putFeV1SchedulationsId$Json.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.header('X-Correlation-Id', params['X-Correlation-Id'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SchedulationResponse>;
    })
  );
}

putFeV1SchedulationsId$Json.PATH = '/v1/schedulations/{id}';
